<template>
  <div>
    <my-head></my-head>
    <div class="inter-details minH">
      <div class="crumbs">
        <router-link class="crumb-link" to="/">首页</router-link>
        >
        <router-link class="crumb-link" :to="listPath">信息互联</router-link>
        >
        <span>详情</span>
      </div>

      <h1 class="title">{{ data.title }}</h1>
      <div class="publish-time" v-if="data.createTime">
        {{ data.createTime | dateYMD }}
      </div>

      <div class="article-card">
        <div class="article-body" v-html="normalizedContent"></div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import { getRequest } from "../api/api";

export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      data: {},
    };
  },
  computed: {
    normalizedContent() {
      return this.normalizeHtml(this.data.content);
    },
    listPath() {
      const category = this.data && this.data.category;
      if (category === 1 || category === "1") {
        return { path: "/interconnection", query: { tab: "3" } };
      }
      return "/interconnection";
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getRequest({ url: `/api/v1/newsInter/${this.$route.query.id}` }).then(
        (res) => {
          this.data = res.data || {};
        }
      );
    },
    normalizeHtml(html) {
      if (!html) return "";
      if (typeof window === "undefined" || !window.DOMParser) return html;

      const doc = new DOMParser().parseFromString(
        `<div id="inter-root">${html}</div>`,
        "text/html"
      );
      const root = doc.getElementById("inter-root");
      if (!root) return html;

      root.querySelectorAll("[style]").forEach((el) => {
        const align = (el.getAttribute("style") || "").match(
          /text-align\s*:\s*(center|left|right|justify)/i
        );
        el.removeAttribute("style");
        if (align) el.style.textAlign = align[1].toLowerCase();
      });

      root.querySelectorAll("span").forEach((span) => {
        if (!span.attributes.length) {
          const parent = span.parentNode;
          if (!parent) return;
          while (span.firstChild) parent.insertBefore(span.firstChild, span);
          parent.removeChild(span);
        }
      });

      root.querySelectorAll("p").forEach((p) => {
        const text = (p.textContent || "").replace(/\u00a0/g, " ").trim();
        if (!text && !p.querySelector("img, table, a, figure")) {
          p.remove();
        }
      });

      const textWalker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (textWalker.nextNode()) textNodes.push(textWalker.currentNode);
      textNodes.forEach((node) => {
        node.nodeValue = node.nodeValue
          .replace(/\u00a0/g, " ")
          .replace(/[ \t]{2,}/g, " ");
      });

      root.querySelectorAll("figure.table table, table").forEach((table) => {
        if (table.closest("figure") && table.closest("figure") !== table.parentElement) {
          return;
        }
        const rows = Array.from(table.querySelectorAll(":scope > tbody > tr, :scope > tr"));
        if (!rows.length) return;
        const cells = Array.from(rows[0].children);
        if (rows.length === 1 && cells.length === 2) {
          table.classList.add("intro-table");
          cells[0].classList.add("intro-label");
          cells[1].classList.add("intro-content");
          cells[0].textContent = (cells[0].textContent || "").replace(/\s+/g, "");
        } else {
          table.classList.add("data-table");
          rows[0].classList.add("head-row");
        }
      });

      this.convertTopLevelBlocks(doc, root);
      return root.innerHTML;
    },
    createMetaGrid(doc, pairs) {
      const grid = doc.createElement("div");
      grid.className = "meta-grid";
      pairs.forEach((pair) => {
        const item = doc.createElement("div");
        item.className = "meta-item";
        const label = doc.createElement("span");
        label.className = "label";
        label.textContent = pair.label;
        const value = doc.createElement("span");
        value.className = "value";
        value.innerHTML = pair.value;
        item.appendChild(label);
        item.appendChild(value);
        grid.appendChild(item);
      });
      return grid;
    },
    insertBeforeRef(root, el, refNode) {
      if (refNode && refNode.parentNode === root) {
        root.insertBefore(el, refNode);
      } else {
        root.appendChild(el);
      }
    },
    convertTopLevelBlocks(doc, root) {
      const children = Array.from(root.childNodes);
      const pendingMeta = [];

      const flushMeta = (refNode) => {
        if (!pendingMeta.length) return;
        const grid = this.createMetaGrid(doc, pendingMeta.splice(0));
        this.insertBeforeRef(root, grid, refNode);
      };

      children.forEach((node) => {
        if (node.nodeType !== 1 || node.tagName !== "P") {
          flushMeta(node);
          return;
        }

        if (!this.startsWithStrong(node)) {
          flushMeta(node);
          return;
        }

        const pairs = this.extractPairs(node);
        if (pairs.length >= 2) {
          pendingMeta.push(...pairs);
          node.remove();
          return;
        }

        flushMeta(node);

        if (pairs.length === 1) {
          const pair = pairs[0];
          const valueText = pair.value.replace(/<[^>]+>/g, "").trim();
          if (!pair.hadColon && !valueText) {
            const heading = doc.createElement("h2");
            heading.className = "section-title";
            heading.textContent = pair.label;
            node.parentNode.replaceChild(heading, node);
          } else {
            const row = doc.createElement("div");
            row.className = "info-row";
            const label = doc.createElement("span");
            label.className = "label";
            label.textContent = pair.label;
            const value = doc.createElement("span");
            value.className = "value";
            value.innerHTML = pair.value;
            row.appendChild(label);
            row.appendChild(value);
            node.parentNode.replaceChild(row, node);
          }
        }
      });

      flushMeta(null);
    },
    startsWithStrong(p) {
      const html = (p.innerHTML || "")
        .replace(/^(\s|&nbsp;|<span[^>]*>|<\/span>)*/gi, "")
        .trim();
      return /^<strong\b/i.test(html);
    },
    extractPairs(p) {
      const html = p.innerHTML || "";
      const strongs = [];
      const re = /<strong\b[^>]*>([\s\S]*?)<\/strong>/gi;
      let match;
      while ((match = re.exec(html))) {
        strongs.push({
          raw: match[1],
          index: match.index,
          end: match.index + match[0].length,
        });
      }
      if (!strongs.length) return [];
      return strongs.map((item, i) => {
        const rawLabel = item.raw
          .replace(/<[^>]+>/g, "")
          .replace(/\s+/g, " ")
          .trim();
        const hadColon = /[:：]\s*$/.test(rawLabel);
        const label = rawLabel.replace(/[:：\s]+$/g, "").trim();
        const valueStart = item.end;
        const valueEnd = i + 1 < strongs.length ? strongs[i + 1].index : html.length;
        const value = html.slice(valueStart, valueEnd).trim();
        return { label, value, hadColon };
      }).filter((item) => item.label);
    },
  },
};
</script>

<style lang="scss">
.inter-details {
  width: 80%;
  margin: 0 auto 60px;

  .crumbs {
    font-size: 12px;
    color: #86909c;
    margin: 24px 0 32px;

    span {
      color: #1d2129;
    }

    .crumb-link {
      color: #86909c;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        color: #165dff;
      }
    }
  }

  .title {
    font-size: 30px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
    text-align: center;
    margin: 0 0 12px;
  }

  .publish-time {
    text-align: center;
    font-size: 13px;
    color: #86909c;
    margin-bottom: 24px;
  }

  .article-card {
    background: #ffffff;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    padding: 32px 36px 40px;
  }

  .article-body {
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    font-size: 14px;
    color: #1d2129;
    line-height: 1.8;

    * {
      font-size: inherit !important;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    p {
      margin: 0 0 12px;
      color: #4e5969;
    }

    a {
      color: #165dff;
      text-decoration: none;
      word-break: break-all;

      &:hover {
        text-decoration: underline;
      }
    }

    .meta-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 16px 32px;
      padding: 4px 0 8px;
      margin-bottom: 28px;
    }

    .meta-item {
      display: flex;
      align-items: flex-start;
      min-width: 0;
      line-height: 22px;
    }

    .meta-item .label,
    .info-row .label {
      flex: 0 0 auto;
      font-weight: 600;
      color: #1d2129;
      margin-right: 0;
    }

    .meta-item .label::after,
    .info-row .label::after {
      content: "：";
      font-weight: 600;
    }

    .meta-item .value,
    .info-row .value {
      color: #4e5969;
      min-width: 0;
      word-break: break-all;
    }

    figure.table {
      margin: 0 0 28px;
      overflow-x: auto;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #e5e6eb;
      background: #fff;
    }

    table.data-table {
      min-width: 720px;

      td,
      th {
        padding: 10px 12px;
        border: 1px solid #e5e6eb;
        text-align: center;
        color: #4e5969;
        vertical-align: middle;
      }

      tr.head-row td,
      tr.head-row th {
        background: #f7f8fa;
        font-weight: 600;
        color: #1d2129;
      }

      p {
        margin: 0;
        color: inherit;
      }
    }

    table.intro-table {
      border: 1px solid #e5e6eb;

      td {
        border: none;
        vertical-align: middle;
      }

      .intro-label {
        width: 56px;
        background: #f7f8fa;
        border-right: 1px solid #e5e6eb;
        font-weight: 600;
        color: #1d2129;
        text-align: center;
        writing-mode: vertical-rl;
        letter-spacing: 0.45em;
        padding: 20px 0;
      }

      .intro-content {
        padding: 20px 24px;
        color: #1d2129;
        text-align: left;
        line-height: 1.9;
        font-size: 14px;
      }
    }

    .section-title {
      font-size: 22px !important;
      font-weight: bold;
      color: #1d2129;
      line-height: 32px;
      margin: 8px 0 20px;
    }

    .info-row {
      display: flex;
      align-items: flex-start;
      padding: 10px 0;
      line-height: 24px;
    }

    .info-row .label {
      width: 320px;
      flex: 0 0 320px;
      white-space: nowrap;
    }

    .info-row + .info-row {
      border-top: none;
    }
  }
}

@media (max-width: 960px) {
  .inter-details .article-body .meta-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .inter-details .article-card {
    padding: 20px 16px 28px;
  }

  .inter-details .article-body .info-row .label {
    width: 200px;
    flex-basis: 200px;
    white-space: normal;
  }
}
</style>
